// extracted by mini-css-extract-plugin
module.exports = {"button":"CartDrawerFooter_button__VcDUY","title":"CartDrawerFooter_title__eXTlL"};